<template>
  <div id="assist__top" :class="{ no__padding: noPaddingBottom }">
    <h1>
      <i v-if="icon" :class="icon" />
      <i v-else class="anyteachicon anyteach-zhulihuodong"></i>
      {{ title }}
    </h1>
    <p>{{ sub }}</p>
    <p>{{ desc }}</p>
  </div>
</template>

<script>
export default {
  name: "AssistTop",
  props: ["title", "sub", "desc", "noPaddingBottom", "icon"],
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

#assist__top {
  text-align: center;
  background: $purple;
  padding: 25px 0 20px 0;
  h1,
  p {
    color: white;
  }
  h1 {
    @include title();
    padding: 0 0 5px 0;
    i {
      font-size: inherit;
      margin: 0 0 0 5px;
      font-weight: 400;
    }
  }
  p {
    @include body();
  }
}
.no__padding {
  padding-bottom: 5px !important;
}
</style>
